import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelAvailabilityStatusEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelAvailabilityStatusEntity
